import { render, staticRenderFns } from "./LeisureFacilities.vue?vue&type=template&id=5feb5964&scoped=true"
import script from "./LeisureFacilities.vue?vue&type=script&lang=js"
export * from "./LeisureFacilities.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/leisure.css?vue&type=style&index=0&id=5feb5964&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feb5964",
  null
  
)

export default component.exports